<template>
    <div>
        <modal :show.sync="addCropCycle" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar ciclo cultivo</h6>
                <form @submit.prevent="addItemToList()" data-vv-scope="addCropCycle">
                    <div class="form-group">
                        <label>Ciclo cultivo *</label>
                        <fg-input   tabindex="1"
                                    type="text"
                                    name="ciclo cultivo"
                                    placeholder="ciclo cultivo"
                                    autocomplete="off"
                                    v-validate="modelValidations.cycle_name"
                                    :error="getError('addCropCycle.ciclo cultivo')"
                                    v-model="yields.yieldName">
                        </fg-input>
                    </div>
                    <h6>Rendimientos</h6>
                    <div class="form-group">
                        <label>Anterior * 1</label>
                        <fg-input   tabindex="2"
                                    type="number"
                                    name="anterior"
                                    placeholder="anterior"
                                    autocomplete="off"
                                    v-validate="modelValidations.cycle_yields"
                                    :error="getError('addCropCycle.anterior')"
                                    v-model="yields.yieldPrevious">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Mínimo * 2</label>
                        <fg-input   tabindex="3"
                                    type="number"
                                    name="mínimo"
                                    placeholder="mínimo"
                                    autocomplete="off"
                                    v-validate="modelValidations.cycle_yields"
                                    :error="getError('addCropCycle.mínimo')"
                                    v-model="yields.yieldMinimum">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Máximo * 1</label>
                        <fg-input   tabindex="4"
                                    type="number"
                                    name="máximo"
                                    placeholder="máximo"
                                    autocomplete="off"
                                    v-validate="modelValidations.cycle_yields"
                                    :error="getError('addCropCycle.máximo')"
                                    v-model="yields.yieldMaximum">
                        </fg-input>
                    </div>
                    <div v-if="yieldsComputed != 0" class="alert alert-warning mt-2">
                        <span>Promedio: {{ yieldsComputed }}</span>
                    </div>
                    <div class="form-group">
                        <label>Unidad de producción *</label>
                        <fg-input   tabindex="5">
                                <el-select
                                        class="select-warning"
                                        size="large"
                                        placeholder="Seleccione..."
                                        v-validate="modelValidations.yield_unity"
                                        v-model="yields.yieldUnity"
                                        name="unidad de producción"
                                        :error="getError('addCropCycle.unidad de producción')">
                                <el-option
                                        class="select-warning"
                                        value="Arroba"
                                        label="Arroba">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Atado"
                                        label="Atado">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Bolsa"
                                        label="Bolsa">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Bulto"
                                        label="Bulto">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Caja"
                                        label="Caja">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Canastilla"
                                        label="Canastilla">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Carga"
                                        label="Carga">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Kilo"
                                        label="Kilo">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Libra"
                                        label="Libra">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Lote"
                                        label="Lote">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Otro"
                                        label="Otro">
                                </el-option>
                            </el-select>
                        </fg-input>
                        <span v-show="errors.has('addCropCycle.unidad de producción')" class="text-danger" style="font-size: 11px;">
                            {{ errors.first('addCropCycle.unidad de producción') }}
                        </span>
                    </div>
                    <div class="form-group">
                        <label>Consumo familiar y pérdidas</label>
                        <fg-input   tabindex="6"
                                    type="number"
                                    name="consumo familiar y pérdidas"
                                    placeholder="consumo familiar y pérdidas"
                                    autocomplete="off"
                                    v-validate="modelValidations.cycle_yields"
                                    :error="getError('addCropCycle.consumo familiar y pérdidas')"
                                    v-model="yields.yieldFamiliarConsumption">
                        </fg-input>
                    </div>
                    <div v-if="yieldUnityForSaleComputed != 0" class="alert alert-warning mt-2">
                        <span>Unidades para venta: {{ yieldUnityForSaleComputed }}</span>
                    </div>
                    <div class="form-group">
                        <label>Precio de venta *</label>
                        <vue-numeric  :max=999999999 tabindex="7" currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.item_value" :error="getError('addCropCycle.precio de venta')" separator="." class="form-control" v-model="yields.yieldSalePrice"></vue-numeric>
                        <span v-show="errors.has('addCropCycle.precio de venta')" class="text-danger" style="font-size: 11px;">
                            {{ errors.first('addCropCycle.precio de venta') }}
                        </span>
                    </div>
                    <div v-if="yieldTotalSalesComputed != 0" class="alert alert-warning mt-2">
                        <span>Ingreso: {{ setFormat2(yieldTotalSalesComputed) }}</span>
                    </div>
                    <div class="form-group">
                        <label>Meses producción *</label>
                        <el-select
                            @change="yieldMonthsChange()"
                            class="select-warning"
                            size="large"
                            placeholder="Seleccione..."
                            v-model="yields.yieldMonths"
                            multiple
                            v-validate="modelValidations.yieldMonths"
                            :error="getError('addCropCycle.meses')"
                            tabindex="8"
                            name="meses"
                        >
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Enero')"
                                class="select-warning"
                                value="Enero"
                                label="Enero">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Febrero')"
                                class="select-warning"
                                value="Febrero"
                                label="Febrero">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Marzo')"
                                class="select-warning"
                                value="Marzo"
                                label="Marzo">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Abril')"
                                class="select-warning"
                                value="Abril"
                                label="Abril">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Mayo')"
                                class="select-warning"
                                value="Mayo"
                                label="Mayo">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Junio')"
                                class="select-warning"
                                value="Junio"
                                label="Junio">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Julio')"
                                class="select-warning"
                                value="Julio"
                                label="Julio">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Agosto')"
                                class="select-warning"
                                value="Agosto"
                                label="Agosto">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Septiembre')"
                                class="select-warning"
                                value="Septiembre"
                                label="Septiembre">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Octubre')"
                                class="select-warning"
                                value="Octubre"
                                label="Octubre">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Noviembre')"
                                class="select-warning"
                                value="Noviembre"
                                label="Noviembre">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Diciembre')"
                                class="select-warning"
                                value="Diciembre"
                                label="Diciembre">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="form-group">
                        <label>¿Desea asociar % a la producción? *</label>
                        <el-select
                            @change="yieldAssociateChange()"
                            class="select-warning"
                            size="large"
                            placeholder="Seleccione..."
                            v-model="yields.yieldAssociate"
                            v-validate="modelValidations.yieldAssociate"
                            :error="getError('addCropCycle.asociar % a la producción')"
                            tabindex="8"
                            name="asociar % a la producción"
                        >
                            <el-option
                                class="select-warning"
                                value="Si"
                                label="Si">
                            </el-option>
                            <el-option
                                class="select-warning"
                                value="No"
                                label="No">
                            </el-option>
                        </el-select>
                        <span v-show="errors.has('addCropCycle.asociar % a la producción')" class="text-danger" style="font-size: 11px;">
                            {{ errors.first('addCropCycle.asociar % a la producción') }}
                        </span>
                    </div>
                    <div class="form-group" v-for="(month, index) in yields.yieldAssociateMonths" :key="index">
                        <label>{{ month.name }} * </label>
                        <fg-input 
                            type="number"
                            :name="'Porcentaje '+month.name"
                            placeholder="Porcentaje"
                            autocomplete="off"
                            v-validate="modelValidations.cycle_yields"
                            :error="getError('addCropCycle.Porcentaje ' + month.name)"
                            v-model="month.percent"
                            @input="updateMonthValue(month)">
                        </fg-input>
                        <div class="alert alert-warning mt-2">
                            <span>Ingreso: {{ setFormat(month.value) }}</span>
                        </div>
                    </div>
                </form>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddCrop()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addCropToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editCropCycle" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar ciclo cultivo</h6>
                <form @submit.prevent="editItemToList()" data-vv-scope="editCropCycle">
                    <div class="form-group">
                        <label>Ciclo cultivo *</label>
                        <fg-input   tabindex="1"
                                    type="text"
                                    name="ciclo cultivo"
                                    placeholder="ciclo cultivo"
                                    autocomplete="off"
                                    v-validate="modelValidations.cycle_name"
                                    :error="getError('editCropCycle.ciclo cultivo')"
                                    v-model="yields.yieldName">
                        </fg-input>
                    </div>
                    <h6>Rendimientos</h6>
                    <div class="form-group">
                        <label>Anterior * 1</label>
                        <fg-input   tabindex="2"
                                    type="number"
                                    name="anterior"
                                    placeholder="anterior"
                                    autocomplete="off"
                                    v-validate="modelValidations.cycle_yields"
                                    :error="getError('editCropCycle.anterior')"
                                    v-model="yields.yieldPrevious">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Mínimo * 2</label>
                        <fg-input   tabindex="3"
                                    type="number"
                                    name="mínimo"
                                    placeholder="mínimo"
                                    autocomplete="off"
                                    v-validate="modelValidations.cycle_yields"
                                    :error="getError('editCropCycle.mínimo')"
                                    v-model="yields.yieldMinimum">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Máximo * 1</label>
                        <fg-input   tabindex="4"
                                    type="number"
                                    name="máximo"
                                    placeholder="máximo"
                                    autocomplete="off"
                                    v-validate="modelValidations.cycle_yields"
                                    :error="getError('editCropCycle.máximo')"
                                    v-model="yields.yieldMaximum">
                        </fg-input>
                    </div>
                    <div v-if="yieldsComputed != 0" class="alert alert-warning mt-2">
                        <span>Promedio: {{ yieldsComputed }}</span>
                    </div>
                    <div class="form-group">
                        <label>Unidad de producción *</label>
                        <fg-input   tabindex="5">
                                <el-select
                                        class="select-warning"
                                        size="large"
                                        placeholder="Seleccione..."
                                        v-validate="modelValidations.yield_unity"
                                        v-model="yields.yieldUnity"
                                        name="unidad de producción"
                                        :error="getError('editCropCycle.unidad de producción')">
                                <el-option
                                        class="select-warning"
                                        value="Arroba"
                                        label="Arroba">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Atado"
                                        label="Atado">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Bolsa"
                                        label="Bolsa">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Bulto"
                                        label="Bulto">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Caja"
                                        label="Caja">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Canastilla"
                                        label="Canastilla">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Carga"
                                        label="Carga">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Kilo"
                                        label="Kilo">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Libra"
                                        label="Libra">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Lote"
                                        label="Lote">
                                </el-option>
                                <el-option
                                        class="select-warning"
                                        value="Otro"
                                        label="Otro">
                                </el-option>
                            </el-select>
                        </fg-input>
                        <span v-show="errors.has('editCropCycle.unidad de producción')" class="text-danger" style="font-size: 11px;">
                            {{ errors.first('editCropCycle.unidad de producción') }}
                        </span>
                    </div>
                    <div class="form-group">
                        <label>Consumo familiar y pérdidas</label>
                        <fg-input   tabindex="6"
                                    type="number"
                                    name="consumo familiar y pérdidas"
                                    placeholder="consumo familiar y pérdidas"
                                    autocomplete="off"
                                    v-validate="modelValidations.cycle_yields"
                                    :error="getError('editCropCycle.consumo familiar y pérdidas')"
                                    v-model="yields.yieldFamiliarConsumption">
                        </fg-input>
                    </div>
                    <div v-if="yieldUnityForSaleComputed != 0" class="alert alert-warning mt-2">
                        <span>Unidades para venta: {{ yieldUnityForSaleComputed }}</span>
                    </div>
                    <div class="form-group">
                        <label>Precio de venta *</label>
                        <vue-numeric  :max=999999999 tabindex="7" currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.item_value" :error="getError('editCropCycle.precio de venta')" separator="." class="form-control" v-model="yields.yieldSalePrice"></vue-numeric>
                        <span v-show="errors.has('editCropCycle.precio de venta')" class="text-danger" style="font-size: 11px;">
                            {{ errors.first('editCropCycle.precio de venta') }}
                        </span>
                    </div>
                    <div v-if="yieldTotalSalesComputed != 0" class="alert alert-warning mt-2">
                        <span>Ingreso: {{ setFormat2(yieldTotalSalesComputed) }}</span>
                    </div>
                    <div class="form-group">
                        <label>Meses producción *</label>
                        <el-select
                            @change="yieldMonthsChange()"
                            class="select-warning"
                            size="large"
                            placeholder="Seleccione..."
                            v-model="yields.yieldMonths"
                            multiple
                            v-validate="modelValidations.yieldMonths"
                            :error="getError('editCropCycle.meses')"
                            tabindex="8"
                            name="meses"
                        >
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Enero')"
                                class="select-warning"
                                value="Enero"
                                label="Enero">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Febrero')"
                                class="select-warning"
                                value="Febrero"
                                label="Febrero">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Marzo')"
                                class="select-warning"
                                value="Marzo"
                                label="Marzo">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Abril')"
                                class="select-warning"
                                value="Abril"
                                label="Abril">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Mayo')"
                                class="select-warning"
                                value="Mayo"
                                label="Mayo">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Junio')"
                                class="select-warning"
                                value="Junio"
                                label="Junio">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Julio')"
                                class="select-warning"
                                value="Julio"
                                label="Julio">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Agosto')"
                                class="select-warning"
                                value="Agosto"
                                label="Agosto">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Septiembre')"
                                class="select-warning"
                                value="Septiembre"
                                label="Septiembre">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Octubre')"
                                class="select-warning"
                                value="Octubre"
                                label="Octubre">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Noviembre')"
                                class="select-warning"
                                value="Noviembre"
                                label="Noviembre">
                            </el-option>
                            <el-option
                                :disabled="isMonthAlreadyAssigned('Diciembre')"
                                class="select-warning"
                                value="Diciembre"
                                label="Diciembre">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="form-group">
                        <label>¿Desea asociar % a la producción? *</label>
                        <el-select
                            @change="yieldAssociateChange()"
                            class="select-warning"
                            size="large"
                            placeholder="Seleccione..."
                            v-model="yields.yieldAssociate"
                            v-validate="modelValidations.yieldAssociate"
                            :error="getError('editCropCycle.asociar % a la producción')"
                            tabindex="8"
                            name="asociar % a la producción"
                        >
                            <el-option
                                class="select-warning"
                                value="Si"
                                label="Si">
                            </el-option>
                            <el-option
                                class="select-warning"
                                value="No"
                                label="No">
                            </el-option>
                        </el-select>
                        <span v-show="errors.has('editCropCycle.asociar % a la producción')" class="text-danger" style="font-size: 11px;">
                            {{ errors.first('editCropCycle.asociar % a la producción') }}
                        </span>
                    </div>
                    <div class="form-group" v-for="(month, index) in yields.yieldAssociateMonths" :key="index">
                        <label>{{ month.name }} * </label>
                        <fg-input 
                            type="number"
                            :name="'Porcentaje '+month.name"
                            placeholder="Porcentaje"
                            autocomplete="off"
                            v-validate="modelValidations.cycle_yields"
                            :error="getError('editCropCycle.Porcentaje ' + month.name)"
                            v-model="month.percent"
                            @input="updateMonthValue(month)">
                        </fg-input>
                        <div class="alert alert-warning mt-2">
                            <span>Ingreso: {{ setFormat(month.value) }}</span>
                        </div>
                    </div>
                </form>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditCrop()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editCropToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="addItem" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar edad</h6>
                <form @submit.prevent="addItemToList()" data-vv-scope="addItem">
                    <div class="form-group">
                        <label>Edad *</label>
                        <fg-input   tabindex="1"
                                    type="text"
                                    name="edad"
                                    placeholder="edad"
                                    autocomplete="off"
                                    v-validate="modelValidations.age_name"
                                    :error="getError('addItem.edad')"
                                    v-model="itemName">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Cantidad *</label>
                        <fg-input   tabindex="2"
                                    type="text"
                                    name="cantidad"
                                    placeholder="cantidad"
                                    autocomplete="off"
                                    v-validate="modelValidations.item_qty"
                                    :error="getError('addItem.cantidad')"
                                    v-model="itemQty">
                        </fg-input>
                    </div>
                </form>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddItem()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addItemToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editItem" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar edad</h6>
                <form @submit.prevent="editItemToList()" data-vv-scope="editItem">
                    <div class="form-group">
                        <label>Edad *</label>
                        <fg-input   tabindex="1"
                                    type="text"
                                    name="edad"
                                    placeholder="edad"
                                    autocomplete="off"
                                    v-validate="modelValidations.age_name"
                                    :error="getError('editItem.edad')"
                                    v-model="itemName">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Cantidad *</label>
                        <fg-input   tabindex="2"
                                    type="text"
                                    name="cantidad"
                                    placeholder="cantidad"
                                    autocomplete="off"
                                    v-validate="modelValidations.item_qty"
                                    :error="getError('editItem.cantidad')"
                                    v-model="itemQty">
                        </fg-input>
                    </div>
                </form>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditItem()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editItemToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="addProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar cultivo</h6>
                <form @submit.prevent="addProductToList()" data-vv-scope="addProduct">
                    <div class="form-group">
                        <label>Tipo de cultivo *</label>
                        <fg-input   tabindex="1"
                                    type="text"
                                    name="tipo de cultivo"
                                    placeholder="tipo de cultivo"
                                    autocomplete="off"
                                    v-validate="modelValidations.item_name"
                                    :error="getError('addProduct.tipo de cultivo')"
                                    v-model="historicalName">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Cantidad *</label>
                        <fg-input   tabindex="2"
                                    type="text"
                                    name="cantidad"
                                    placeholder="cantidad"
                                    autocomplete="off"
                                    v-validate="modelValidations.item_qty"
                                    :error="getError('addProduct.cantidad')"
                                    v-model="historicalQty">
                        </fg-input>
                    </div>
                </form>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addProductToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar cultivo</h6>
                <form @submit.prevent="editProductToList()" data-vv-scope="editProduct">
                    <div class="form-group">
                        <label>Tipo de cultivo *</label>
                        <fg-input   tabindex="1"
                                    type="text"
                                    name="instalacion"
                                    placeholder="instalacion"
                                    autocomplete="off"
                                    v-validate="modelValidations.item_name"
                                    :error="getError('editProduct.instalacion')"
                                    v-model="historicalName">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Cantidad *</label>
                        <fg-input   tabindex="2"
                                    type="text"
                                    name="cantidad"
                                    placeholder="cantidad"
                                    autocomplete="off"
                                    v-validate="modelValidations.item_qty"
                                    :error="getError('editProduct.cantidad')"
                                    v-model="historicalQty">
                        </fg-input>
                    </div>
                </form>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editProductToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <!-- Yields -->
        <card v-if="!addYieldInformation" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">CULTIVOS A AGREGAR</h6>
            </div>
            <div class="card-body">
                <el-table @expand-change="handleExpandChange" v-if="products.length" :data="products"  ref="productsTable"  highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Tipo: {{ props.row.historicalName }}</p>
                            <p>Cantidad : {{ props.row.historicalQty }}</p>
                            <el-table ref="itemsTable"  highlight-current-row @current-change="handleCurrentItemChange" v-if="props.row.historicalItems.length > 0" :data="props.row.historicalItems">
                                <el-table-column label="Edad" property="itemName"></el-table-column>
                                <el-table-column label="Cantidad" property="itemQty"></el-table-column>
                                <el-table-column
                                :min-width="120"
                                class-name="td-actions"
                                label="Más">
                                    <template slot-scope="props">
                                        <el-tooltip content="Rendimientos" placement="left">
                                            <p-button @click="toggleCard(props)" type="warning" size="sm" icon>
                                                <i class="fa fa-plus"></i>
                                            </p-button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <br>
                            <div>
                                <p-button 
                                    @click="addItemMethod(props.$index, props.row)"
                                    type="default" 
                                    >
                                    <i class="mr-2 fa fa-plus"></i>Agregar edad
                                </p-button>
                            </div>
                            <br>
                            <div v-if="currentItemRow">
                                <p-button 
                                    @click="editItemMethod(props.$index, props.row)"
                                    type="default" >
                                    <i class="mr-2 fa fa-pencil"></i>Editar edad
                                </p-button>
                            </div>
                            <br>
                            <div v-if="currentItemRow">
                                <p-button 
                                    @click="removeItem(props.$index)"
                                    type="default" >
                                    <i class="mr-2 fa fa-minus"></i>Quitar edad
                                </p-button>
                            </div>
                            <br> 
                        </template>
                    </el-table-column>
                    <el-table-column label="Tipo" property="historicalName"></el-table-column>
                    <el-table-column label="Cantidad" property="historicalQty"></el-table-column>
                </el-table>
                
                <div>
                    <p-button 
                        v-if="products.length < 5"
                        @click="addProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar cultivo
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar cultivo
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar cultivo
                    </p-button>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <card v-if="addYieldInformation"  class="form-horizontal">
            <div class="card-header text-center">
                <h6 class="card-title-orange">{{ selectedProduct.historicalName }}</h6>
                <h6 class="card-title">{{ selectedRow.itemName }}</h6>
            </div>
            <div class="card-body">
                <card-dark class="form-horizontal">
                    <div class="card-header text-center">
                        <h6 class="card-title">PROYECCIÓN DE INGRESOS AGRÍCOLAS RENDIMIENTOS HISTÓRICOS</h6>
                        <p-button v-if="selectedProduct.historicalItems[selectedItemIndex].itemCrops.length == 0" @click="addCropCycleMethod()"
                            type="default" >
                            <i class="mr-2 fa fa-plus"></i>Ciclo cultivo
                        </p-button>
                    </div>
                    <div class="card-body">
                        <el-table ref="cropsTable"  highlight-current-row @current-change="handleCurrentCropChange" v-if="selectedProduct.historicalItems[selectedItemIndex].itemCrops.length > 0" :data="selectedProduct.historicalItems[selectedItemIndex].itemCrops">
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <p>Ciclo cultivo: {{ props.row.yieldName }}</p>
                                    <p>Anterior*1 : {{ props.row.yieldPrevious }}</p> 
                                    <p>Mínimo*2: {{ props.row.yieldMinimum }}</p>
                                    <p>Máximo*1 : {{ props.row.yieldMaximum }}</p> 
                                    <p>Promedio: {{ props.row.yieldAvg }}</p>
                                    <p>Unidad de producción : {{ props.row.yieldUnity }}</p> 
                                    <p>Consumo familiar y pérdidas: {{ props.row.yieldFamiliarConsumption }}</p>
                                    <p>Unidades para venta : {{ props.row.yieldUnityForSale }}</p> 
                                    <p>Precio de venta: {{ setFormat(props.row.yieldSalePrice) }}</p>
                                    <p>Ingreso : {{ setFormat(props.row.yieldSaleTotal) }}</p> 
                                    <p>Meses producción:</p>
                                        <ul>
                                            <li v-for="(month, index) in props.row.yieldMonths" :key="index">
                                                <strong>{{ month }}</strong>: 
                                            </li>
                                        </ul>
                                    <p>¿Asociar % a la producción?: {{ props.row.yieldAssociate }}</p>
                                    <!-- Condicional para mostrar los meses asociados si yieldAssociate es "Si" -->
                                    <div v-if="props.row.yieldAssociate === 'Si'">
                                        <p>Meses asociados a la producción:</p>
                                        <ul>
                                            <li v-for="(month, index) in props.row.yieldAssociateMonths" :key="index">
                                                <strong>{{ month.name }}</strong>: 
                                                {{ month.percent !== null ? month.percent + '%' : 'Sin porcentaje asignado' }},
                                                Valor: {{ month.value !== '' ? setFormat(month.value) : 'Sin valor calculado' }}
                                            </li>
                                        </ul>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Ciclo" property="yieldName"></el-table-column>
                            <el-table-column label="Total">
                                <template slot-scope="scope">
                                    <span >{{ setFormat(scope.row.yieldSaleTotal )}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div>
                            <br>
                            <div v-if="selectedProduct.historicalItems[selectedItemIndex].itemCrops.length > 0 && selectedProduct.historicalItems[selectedItemIndex].itemCrops.length < 8">
                                <p-button 
                                    @click="addCropCycleMethod()"
                                    type="default" 
                                    >
                                    <i class="mr-2 fa fa-plus"></i>Agregar ciclo
                                </p-button>
                            </div>
                            <br>
                            <div v-if="currentCropRow">
                                <p-button 
                                    @click="editCropCycleMethod()"
                                    type="default" >
                                    <i class="mr-2 fa fa-pencil"></i>Editar ciclo
                                </p-button>
                            </div>
                            <br>
                            <div v-if="currentCropRow">
                                <p-button 
                                    @click="removeCropCycleMethod()"
                                    type="default" >
                                    <i class="mr-2 fa fa-minus"></i>Quitar ciclo
                                </p-button>
                            </div>
                            <br> 
                        </div>
                    </div>
                </card-dark>  
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="cancelYields()" type="warning">Guardar</p-button>
                    <p-button @click="cancelYields()" type="default" class="pull-left mb-3">Cancelar</p-button>
                </div>
            </div>
        </card>
        <div v-if="!addYieldInformation" class="text-right">
            <p-button @click="saveData()" type="warning">Siguiente</p-button>
            <p-button @click="toMenu()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, CardDark, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn, Button} from 'element-ui'
    import Expenses from 'src/util/Others/OperatingExpenses'
    import Taxes from 'src/util/Services/Taxes'
    import moment from 'moment'
    import { Tooltip } from 'element-ui'
    import { Validator } from "vee-validate";
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Table)
    Vue.use(TableColumn)

    Validator.extend('no_leading_zeros', {
        validate: (value) => {
            value = String(value).trim();

            // Permitir exactamente "0"
            if (value === '0') return true;

            // No permitir ceros a la izquierda (excepto "0" como único valor)
            if (/^0\d+/.test(value)) return false;

            // Rechazar números que son exactamente 0.0000 (o equivalentes)
            if (parseFloat(value) === 0) return false;

            // Debe ser un número válido (enteros o decimales positivos)
            return /^\d+(\.\d+)?$/.test(value);
        },
        getMessage: field => `${field} no debe tener ceros a la izquierda.`
    });
    export default {
        components: {
            Card,
            CardDark,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            [Button.name]: Button,
            [Tooltip.name]: Tooltip,
        },
        data() {
        return {
            cashFlowData: null,
            selectedRow: null, // Fila seleccionada
            selectedProduct: null, // Producto padre seleccionado
            selectedItemIndex: null, // Índice del ítem seleccionado
            form: {
                average_selection: '',
            },
            operatingSwitches: {
                expenses: false,
                inventory: false,
            },
            yields: {
                yieldName: '',
                yieldPrevious: '',
                yieldMinimum: '',
                yieldMaximum: '',
                yieldAvg: '',
                yieldUnity: '',
                yieldFamiliarConsumption: '',
                yieldUnityForSale: '',
                yieldSalePrice: '',
                yieldSaleTotal: '',
                yieldMonths: [],
                yieldAssociate: '',
                yieldAssociateMonths: []
            },
            addYieldInformation: false,
            microcredit: false,
            consumer: false,
            pyme: false,
            expenses : [],
            addCropCycle: false,
            editCropCycle: false,
            addItem: false,
            editItem: false,
            addItemIndex: null,
            editItemIndex: null,
            actualExpenses: [],
            currentRow: null,
            currentItemRow: null,
            currentCropRow: null,
            addExpense: false,
            editExpense: false,
            addExpenseIndex: null,
            addProduct: false,
            editProduct: false,
            addProductIndex: null,
            monthlyNumber: '',
            expenseName: '',
            expenseValue: '',
            expenseLocked: false,
            productName: '',
            productQuantity: '',
            productCostUnity: '',
            productSaleUnity: '',
            productCostTotal: '',
            productMonthlyCost: '',
            historicalName: '',
            historicalQty: '',
            itemName: '',
            itemQty: '',
            inventoryValue: '',
            inventoryTotal: '',
            referenceDescription: '',
            skipWatch: false,
            products: [
                
            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                cycle_name: {
                    required: true,
                    max: 30,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                cycle_yields: {
                    required: true,
                    max: 6,
                    no_leading_zeros: true
                },
                yield_unity: {
                    required: true,
                    max: 10
                },
                yieldMonths: {
                    required: true,
                },
                yieldAssociate: {
                    required: true,
                },
                item_value: {
                    required: true,
                    max: 9
                },
                item_name: {
                    required: true,
                    max: 30,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                age_name: {
                    required: true,
                    max: 10,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                item_qty: {
                    required: true,
                    max: 20,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                }
            },
        }
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.expenses': function (newVal, oldVal) {
                if (!newVal) {
                    this.actualExpenses = [];
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.inventory': function (newVal, oldVal) {
                if (!newVal) {
                    this.products = []
                }
            },
        },
        computed: {
            yieldTotalSalesComputed() {
                const unityForSale = parseFloat(this.yields.yieldUnityForSale) || 0;
                const salePrice = parseFloat(this.yields.yieldSalePrice) || 0;

                // Validamos que los valores no sean negativos.
                const totalSales = Math.max(0, unityForSale * salePrice);
                // Guardamos el resultado en `yields.yieldSaleTotal` antes de retornarlo.
                this.yields.yieldSaleTotal = Math.round(totalSales * 100) / 100; // Máximo 2 decimales.

                return this.yields.yieldSaleTotal;
            },
            yieldUnityForSaleComputed() {
                const { yieldAvg, yieldFamiliarConsumption } = this.yields;

                // Calculamos la unidad para la venta restando el consumo familiar
                const familiarConsumption = parseFloat(yieldFamiliarConsumption) || 0;
                const unityForSale = (parseFloat(yieldAvg) || 0) - familiarConsumption;

                // // Guardamos el resultado en yields.yieldUnityForSale
                // this.yields.yieldUnityForSale = unityForSale >= 0 ? unityForSale : 0;

                // // Retornamos el resultado
                // return this.yields.yieldUnityForSale;
                 // Asegura que sea al menos 0 y con máximo 2 decimales
                const result = unityForSale >= 0 ? unityForSale : 0;

                // Redondeamos a 2 decimales
                const rounded = Math.round(result * 100) / 100;

                // Asignamos el valor
                this.yields.yieldUnityForSale = rounded;

                return rounded;

            },
            yieldsComputed() {
                const { yieldPrevious, yieldMinimum, yieldMaximum } = this.yields;

                // Aseguramos que los valores sean numéricos, si no lo son, asumimos 0
                const previous = parseFloat(yieldPrevious) || 0;
                const minimum = (parseFloat(yieldMinimum) || 0) * 2; // Multiplicamos minimum por 2
                const maximum = parseFloat(yieldMaximum) || 0;

                // Calculamos el promedio
                const sum = previous + minimum + maximum;
                const average = sum / 4;

                // Redondeamos a 2 decimales si tiene más
                const roundedAverage = !isNaN(average) ? parseFloat(average.toFixed(2)) : 0;

                // Actualizamos yields.yieldAvg
                this.yields.yieldAvg = roundedAverage;

                return roundedAverage;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifyNext () {
                if (!this.operatingSwitches.expenses && !this.operatingSwitches.inventory) {
                    return true
                }
                else if(this.operatingSwitches.expenses && this.operatingSwitches.inventory &&  this.allExpensesMonthlyCostComputed != 0 && this.totalInventory != 0) {
                    return true
                }
                else if(this.operatingSwitches.expenses  &&  this.allExpensesMonthlyCostComputed ) {
                    if(!this.operatingSwitches.inventory) {
                        return true
                    }
                }
                else if(this.operatingSwitches.inventory  &&  this.totalInventory ) {
                    if(!this.operatingSwitches.expenses) {
                        return true
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productSaleUnity;
                this.productCostTotal = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            totalInventory() {
                var sum = 0;
                for (let i = 0;i<this.products.length;i++) {
                    sum = sum + this.products[i].inventoryValue; 
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allExpensesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    sum = sum + (this.actualExpenses[i].value);
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allExpensesMonthlyCostComputed
            }
        },
        methods: {
            calculateMonthlyTotalsByHistoricalName() {
                let allMonthData = {}; // Objeto principal que almacenará cada producto con su monthData
                let totalizedYields = {}; // Almacena el total acumulado de cada producto
                this.products.forEach((product, productIndex) => { 
                let monthData = {}; // Objeto que almacenará los valores por mes para este producto

                product.historicalItems.forEach(item => { 
                    item.itemCrops.forEach(crop => { 
                    if (crop.yieldAssociate === "Si") {
                        // Si es asociado, iteramos sobre yieldAssociateMonths
                        crop.yieldAssociateMonths.forEach(month => {
                        if (!monthData[month.name]) {
                            monthData[month.name] = 0;
                        }
                        monthData[month.name] += month.value;
                        });
                    } else {
                        // Si NO es asociado, usamos yieldSaleTotal y yieldMonths
                        crop.yieldMonths.forEach(month => {
                        if (!monthData[month]) {
                            monthData[month] = 0;
                        }
                        monthData[month] += crop.yieldSaleTotal;
                        });
                    }
                    });
                });

                // Asignamos el monthData de este producto en la posición productIndex
                allMonthData[productIndex] = monthData;
                });
                console.log(allMonthData);
                // return monthData;
                
                let updatedMonths = JSON.parse(JSON.stringify(this.cashFlowData.months)); // Copia profunda
                updatedMonths.forEach(monthData => {
                let monthName = monthData.name.split('/')[0]; // Extraemos el nombre del mes (Ej: "Marzo" de "Marzo/25")

                // Creamos la estructura dentro de cada mes
                monthData.historicalYields = [];

                // 3️⃣ TERCER PASO: Insertamos los valores obtenidos en el primer paso
                Object.keys(allMonthData).forEach(productIndex => {
                    let productValues = allMonthData[productIndex];

                    let value = productValues[monthName] || 0; // Buscamos el valor, si no existe, es 0

                    monthData.historicalYields.push({
                    productIndex: parseInt(productIndex), // Índice del producto
                    value: value // Valor de rendimiento
                    });
                    // 4️⃣ CUARTO PASO: Totalizar cada producto en todos los meses
                    if (!totalizedYields[productIndex]) {
                    totalizedYields[productIndex] = 0;
                    }
                    totalizedYields[productIndex] += value;
                });
                });
                this.cashFlowData.months = updatedMonths;
                this.cashFlowData.totalizedYields = totalizedYields;
                
            },
            isMonthAlreadyAssigned(month) {
                // Verifica si el producto y el índice seleccionado existen
                if (
                    !this.selectedProduct ||
                    !Array.isArray(this.selectedProduct.historicalItems) ||
                    !this.selectedProduct.historicalItems[this.selectedItemIndex]
                ) {
                    return false; // No hay datos válidos para validar
                }

                const itemCrops = this.selectedProduct.historicalItems[this.selectedItemIndex].itemCrops;

                // Verifica si itemCrops es un array válido
                if (!Array.isArray(itemCrops)) {
                    return false; // No hay cultivos en este índice
                }

                // Itera sobre todos los cultivos en itemCrops para verificar si el mes ya está asignado
                for (const crop of itemCrops) {
                    if (
                        Array.isArray(crop.yieldMonths) &&
                        crop.yieldMonths.includes(month)
                    ) {
                        return true; // El mes ya está asignado en otro cultivo
                    }
                }

                return false; // El mes no está asignado
            },
            validateProductsData() {
                // Verifica si products es un array y no está vacío
                if (!Array.isArray(this.products) || this.products.length === 0) {
                    this.showNotificationError('No hay datos en la lista de cultivos.');
                    return false;
                }

                // Itera sobre cada producto para validar historicalItems
                for (const product of this.products) {
                    if (
                        !product.historicalItems || 
                        !Array.isArray(product.historicalItems) || 
                        product.historicalItems.length === 0
                    ) {
                        this.showNotificationError('El producto no contiene edades.');
                        return false;
                    }

                    // Itera sobre cada historicalItem para validar itemCrops
                    for (const historicalItem of product.historicalItems) {
                        if (
                            !historicalItem.itemCrops || 
                            !Array.isArray(historicalItem.itemCrops) || 
                            historicalItem.itemCrops.length === 0
                        ) {
                            this.showNotificationError('Las edades no contienen ciclos de cultivos.');
                            return false;
                        }
                    }
                }

                // Si todas las validaciones pasan
                return true;
            },
            validateFirstCrop() {
                const itemCrops = this.selectedProduct.historicalItems[this.selectedItemIndex].itemCrops;

                // Verificamos que no haya cultivos y que currentCropRow sea null, o si no es null que esté en el primer índice
                //return itemCrops.length === 0 || itemCrops.indexOf(this.currentCropRow) === 0;
                return true
            },
            yieldAssociateChange(){
                if(!this.validateFirstCrop()){
                    if (this.yields.yieldAssociate === 'Si' && Array.isArray(this.yields.yieldMonths)) {
                        // Si yieldAssociate es "Si" y yieldMonths es un arreglo
                        const months = this.yields.yieldMonths.map(month => ({
                            name: month,    // Nombre del mes
                            percent: null,  // Inicializamos percent como null
                            value: this.yields.yieldSaleTotal
                        }));
                        
                        // Actualizamos yields.yieldAssociateMonths con el arreglo generado
                        this.$set(this.yields, 'yieldAssociateMonths', months);
                    } else {
                        // Si no se cumple la condición, establecemos un arreglo vacío
                        this.$set(this.yields, 'yieldAssociateMonths', []);
                    }
                }
                else {
                    if (this.yields.yieldAssociate === 'Si' && Array.isArray(this.yields.yieldMonths)) {
                        // Si yieldAssociate es "Si" y yieldMonths es un arreglo
                        const months = this.yields.yieldMonths.map(month => ({
                            name: month,    // Nombre del mes
                            percent: null,  // Inicializamos percent como null
                            value: ''       // Inicializamos value como una cadena vacía
                        }));
                        
                        // Actualizamos yields.yieldAssociateMonths con el arreglo generado
                        this.$set(this.yields, 'yieldAssociateMonths', months);
                    } else {
                        // Si no se cumple la condición, establecemos un arreglo vacío
                        this.$set(this.yields, 'yieldAssociateMonths', []);
                    }
                }
                    
                
            },
            yieldMonthsChange(){
                if(!this.validateFirstCrop()){
                    if (this.yields.yieldAssociate === 'Si' && Array.isArray(this.yields.yieldMonths)) {
                        // Si yieldAssociate es "Si" y yieldMonths es un arreglo
                        const months = this.yields.yieldMonths.map(month => ({
                            name: month,    // Nombre del mes
                            percent: null,  // Inicializamos percent como null
                            value: this.yields.yieldSaleTotal
                        }));
    
                        // Actualizamos yields.yieldAssociateMonths con el arreglo generado
                        this.$set(this.yields, 'yieldAssociateMonths', months);
                    } else {
                        // Si no se cumple la condición, establecemos un arreglo vacío
                        this.$set(this.yields, 'yieldAssociateMonths', []);
                    }
                }
                else {
                    if (this.yields.yieldAssociate === 'Si' && Array.isArray(this.yields.yieldMonths)) {
                        // Si yieldAssociate es "Si" y yieldMonths es un arreglo
                        const months = this.yields.yieldMonths.map(month => ({
                            name: month,    // Nombre del mes
                            percent: null,  // Inicializamos percent como null
                            value: ''       // Inicializamos value como una cadena vacía
                        }));
    
                        // Actualizamos yields.yieldAssociateMonths con el arreglo generado
                        this.$set(this.yields, 'yieldAssociateMonths', months);
                    } else {
                        // Si no se cumple la condición, establecemos un arreglo vacío
                        this.$set(this.yields, 'yieldAssociateMonths', []);
                    }
                }
            },
            cancelYields(){
                this.addYieldInformation = false;
                this.currentCropRow = null;
                this.selectedRow = null;
                this.selectedProduct = null;
                this.selectedItemIndex = null;
            },
            resetCrop (){
                this.yields= {
                    yieldName: '',
                    yieldPrevious: '',
                    yieldMinimum: '',
                    yieldMaximum: '',
                    yieldAvg: '',
                    yieldUnity: '',
                    yieldFamiliarConsumption: '',
                    yieldUnityForSale: '',
                    yieldSalePrice: '',
                    yieldSaleTotal: '',
                    yieldMonths: [],
                    yieldAssociate: '',
                    yieldAssociateMonths: []
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addCropToList () {
                this.$validator.validateAll('addCropCycle').then(isValid => {
                    if(isValid){
                        // Verifica si selectedProduct, historicalItems y itemCrops existen
                        if (this.selectedProduct && this.selectedProduct.historicalItems[this.selectedItemIndex]) {
                            const itemCrops = this.selectedProduct.historicalItems[this.selectedItemIndex].itemCrops;

                            // Asegúrate de que yields contiene datos
                            if (this.yields) {
                                // Realiza una copia de this.yields (para evitar alteraciones futuras)
                                const newCropData = { ...this.yields };

                                // Agrega la nueva información al array itemCrops
                                itemCrops.push(newCropData);

                                // Si quieres resetear this.yields después de agregarlo, puedes hacerlo
                                this.resetCrop();
                                this.addCropCycle = false;
                                this.showNotificationSuccess('Ciclo cultivo agregado correctamente');
                                this.errors.clear();
                            } else {
                                console.error('No hay datos para agregar');
                            }
                        } else {
                            console.error('No se encuentra producto seleccionado en el índice seleccionado');
                        }
                    }
                    else {
                        console.error('Error: Campos no diligenciados correctamente');
                        console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                        this.errors.items.forEach(error => {
                            console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                        });
                        this.showNotificationError('Campos no diligenciados correctamente');
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editCropToList () {
                this.$validator.validateAll('editCropCycle').then(isValid => {
                    if(isValid){
                        // Verifica si selectedProduct, historicalItems y itemCrops existen
                        if (this.selectedProduct && this.selectedProduct.historicalItems[this.selectedItemIndex]) {
                            var index = this.selectedProduct.historicalItems[this.selectedItemIndex].itemCrops.indexOf(this.currentCropRow);
                            const itemCrops = this.selectedProduct.historicalItems[this.selectedItemIndex].itemCrops;

                            // Asegúrate de que yields contiene datos
                            if (this.yields) {
                                // Realiza una copia de this.yields (para evitar alteraciones futuras)
                                const newCropData = { ...this.yields };

                                // Agrega la nueva información al array itemCrops
                                itemCrops[index] = newCropData;

                                // Si quieres resetear this.yields después de agregarlo, puedes hacerlo
                                this.resetCrop();
                                this.editCropCycle = false;
                                this.currentCropRow = null;
                                this.$refs.cropsTable.setCurrentRow();
                                this.showNotificationSuccess('Ciclo cultivo editado correctamente');
                                this.errors.clear();
                                console.log(this.products);
                            } else {
                                console.error('No hay datos para agregar');
                            }
                        } else {
                            console.error('No se encuentra producto seleccionado en el índice seleccionado');
                        }
                    }
                    else {
                        console.error('Error: Campos no diligenciados correctamente');
                        console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                        this.errors.items.forEach(error => {
                            console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                        });
                        this.showNotificationError('Campos no diligenciados correctamente');
                    }
                })
            },
            cancelAddCrop(){
                this.addCropCycle = false;
                this.resetCrop();
                this.errors.clear();
            },
            cancelEditCrop(){
                this.editCropCycle = false;
                this.currentCropRow = null;
                this.resetCrop();
                this.errors.clear();
                this.$refs.cropsTable.setCurrentRow();
            },
            updateMonthValue(month) {
                console.log(this.yields.yieldAssociateMonths);
                let totalPercent = 0;
                this.yields.yieldAssociateMonths.forEach(item => {
                    // Convierte el porcentaje a número si es necesario
                    const percentValue = parseFloat(item.percent);

                    // Valida que el valor sea un número válido antes de sumarlo
                    if (!isNaN(percentValue)) {
                        totalPercent += percentValue;
                    }
                });

                if (totalPercent > 100) {
                    this.showNotificationError('El total de los porcentajes supera 100');
                    month.percent = null;
                } else {
                    console.log(`El total de los porcentajes es: ${totalPercent}`);
                }
                // Calcula el value multiplicando el porcentaje por yieldSaleTotal
                if (month.percent && this.yields.yieldSaleTotal) {
                    month.value = (month.percent / 100) * this.yields.yieldSaleTotal;
                } else {
                    month.value = 0; // Si no hay porcentaje o saleTotal, asignar 0
                }
            },
            addCropCycleMethod(){
                this.resetCrop();
                this.errors.clear();
                this.addCropCycle = true;
                this.currentCropRow = null;
                this.$refs.cropsTable.setCurrentRow();
            },
            editCropCycleMethod() {
                var index = this.selectedProduct.historicalItems[this.selectedItemIndex].itemCrops.indexOf(this.currentCropRow);
                this.yields = JSON.parse(JSON.stringify(this.selectedProduct.historicalItems[this.selectedItemIndex].itemCrops[index]));
                this.editCropCycle = true;
            },
            removeCropCycleMethod () {
                var index = this.selectedProduct.historicalItems[this.selectedItemIndex].itemCrops.indexOf(this.currentCropRow);
                if (index !== -1) {
                    // Elimina el crop en el índice encontrado
                    this.selectedProduct.historicalItems[this.selectedItemIndex].itemCrops.splice(index, 1);
                    this.currentCropRow = null;
                    this.resetCrop();
                    this.errors.clear();
                    this.showNotificationSuccess('Ciclo cultivo eliminado correctamente');
                } else {
                    console.error('No se encontró el ciclo cultivo en el sistema');
                }
            },
            toggleCard(fullRow) {
                const row = fullRow.row;
                // Encuentra el producto padre
                const product = this.products.find((p) =>
                    p.historicalItems.includes(row)
                );

                if (product) {
                    // Encuentra el índice del ítem
                    const itemIndex = product.historicalItems.indexOf(row);

                    // Actualiza los datos
                    this.selectedRow = row; // El ítem en sí
                    this.selectedProduct = product; // El producto padre
                    this.selectedItemIndex = itemIndex; // Índice del ítem
                } else {
                    // Limpia si no se selecciona nada
                    this.selectedRow = null;
                    this.selectedProduct = null;
                    this.selectedItemIndex = null;
                }
                this.currentRow = null;
                this.currentItemRow = null;
                this.addYieldInformation = true;
                const table = this.$refs.productsTable; // Referencia al el-table
                if (table) {
                    this.products.forEach((row) => {
                    table.toggleRowExpansion(row, false); // Contrae la fila
                    });
                }
            },
            handleExpandChange(row, expanded) {
                this.currentRow = this.products.indexOf(row);
                this.currentItemRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             removeItem (row) {
                this.products[row].historicalItems.splice(this.products[row].historicalItems.indexOf(this.currentItemRow),1);
                this.currentItemRow = null;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemQty = '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelAddItem () {
                this.addItem = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditItem () {
                this.editItem = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addItemToList () {
                this.$validator.validateAll('addItem').then(isValid => {
                    if(isValid){
                        this.products[this.addItemIndex].historicalItems.push({
                            itemName: this.itemName,
                            itemQty: this.itemQty,
                            itemCrops: []
                        })
                        this.resetItem();
                        this.addItem = false;
                        this.addItemIndex = null;
                        this.showNotificationSuccess('Edad agregada correctamente');
                    }
                    else {
                        console.error('Error: Campos no diligenciados correctamente');
                        console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                        this.errors.items.forEach(error => {
                            console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                        });
                        this.showNotificationError('Campos no diligenciados correctamente');
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editItemToList () {
                this.$validator.validateAll('editItem').then(isValid => {
                    if(isValid){
                        var index = this.products[this.editItemIndex].historicalItems.indexOf(this.currentItemRow);
                        this.products[this.editItemIndex].historicalItems[index].itemName = this.itemName;
                        this.products[this.editItemIndex].historicalItems[index].itemQty = this.itemQty;
                        this.resetItem();
                        this.editItem = false;
                        this.editItemIndex = null;
                        this.currentItemRow = null;
                        this.$refs.itemsTable.setCurrentRow();
                        this.showNotificationSuccess('Edad editada correctamente');
                    }
                    else {
                        console.error('Error: Campos no diligenciados correctamente');
                        console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                        this.errors.items.forEach(error => {
                            console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                        });
                        this.showNotificationError('Campos no diligenciados correctamente');
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addItemMethod (index,row) {
                this.addItemIndex = index;
                this.addItem = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editItemMethod (row) {
                this.editItemIndex = row;
                var index = this.products[row].historicalItems.indexOf(this.currentItemRow);
                this.itemName= this.products[row].historicalItems[index].itemName;
                this.itemQty= this.products[row].historicalItems[index].itemQty;
                this.editItem = true;
            },
            toMenu () {
                this.$router.push('/asessments/menu');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (this.$store.state.isCustomer) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    
                }
                else if(this.$store.state.isSpouse) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    
                }
                if (this.$store.state.isGuarantor) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             handleCurrentItemChange(currentRow, oldCurrentRow) {
                this.currentItemRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             handleCurrentCropChange(currentRow, oldCurrentRow) {
                this.currentCropRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var index = this.actualExpenses.indexOf(this.currentRow);
                    this.actualExpenses[index].name = this.expenseName;
                    this.actualExpenses[index].value = this.expenseValue;
                    this.resetExpense();
                    this.currentRow = null;
                    this.$refs.expensesTable.setCurrentRow();
                    this.editExpense = false;
                    this.showNotificationSuccess('Gasto editado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll('addProduct').then(isValid => {
                    if(isValid){
                        this.products.push({
                            historicalName: this.historicalName,
                            historicalQty: this.historicalQty,
                            historicalItems: [],
                            expenses: []
                        })
                        this.resetProduct();
                        this.addProduct = false;
                        this.errors.clear();
                        this.showNotificationSuccess('Cultivo agregado correctamente');
                        }
                        else {
                            console.error('Error: Campos no diligenciados correctamente');
                            console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                            this.errors.items.forEach(error => {
                                console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                            });
                            this.showNotificationError('Campos no diligenciados correctamente');
                        }
                })

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.historicalName = '';
                this.historicalQty = '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductMethod () {
                this.historicalName= this.currentRow.historicalName;
                this.historicalQty= this.currentRow.historicalQty;
                this.editProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll('editProduct').then(isValid => {
                    if(isValid){
                        var index = this.products.indexOf(this.currentRow);
                        this.products[index].historicalName = this.historicalName;
                        this.products[index].historicalQty = this.historicalQty;
                        this.resetProduct();
                        this.currentRow = null;
                        this.$refs.productsTable.setCurrentRow();
                        this.editProduct = false;
                        this.errors.clear();
                        this.showNotificationSuccess('Cultivo editado correctamente');
                    }
                    else {
                        console.error('Error: Campos no diligenciados correctamente');
                        console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                        this.errors.items.forEach(error => {
                            console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                        });
                        this.showNotificationError('Campos no diligenciados correctamente');
                    }
                })
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod (row) {
                this.addProductIndex = row;
                this.errors.clear();
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var id = this.actualExpenses.length + 1;
                    this.actualExpenses.push({
                        id: id,
                        name: this.expenseName,
                        value: this.expenseValue,
                        locked: false
                    })
                    this.resetExpense();
                    this.addExpense = false;
                    this.showNotificationSuccess('Gasto agregado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';   
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseMethod () {
                this.expenseName= this.currentRow.name;
                this.expenseValue= this.currentRow.value;
                this.expenseLocked = this.currentRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             setFormat2 (value) {
                return formatMoney(value, { symbol: "$", precision: 2, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toOperatingExpenses () {
                this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toRequestData () {
                this.$router.push('/asessments/new_asessment/customer/request_data');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             saveData () {
                if (this.validateProductsData()) {
                    this.calculateMonthlyTotalsByHistoricalName();
                    // Extraer todos los itemCrops en un solo array
                    const allItemCrops = this.products.flatMap(yieldObj =>
                        yieldObj.historicalItems.flatMap(item => item.itemCrops)
                    );
                    // Procesar los datos y agregar yieldMonthsString en todos los casos
                    const processedCrops = allItemCrops.map(item => {
                        const yieldMonthsString = item.yieldAssociate === "No"
                            ? item.yieldMonths.join("-") // Si es "No", unir los meses normales
                            : item.yieldAssociateMonths.map(({ name, percent }) => `${name} (${percent}%)`).join("-"); // Si es "Si", unir los asociados

                        return {
                            ...item,
                            yieldMonthsString
                        };
                    });
                    const payload = {
                        products: this.products,
                        allItemCrops: processedCrops,
                        cashFlowData: this.cashFlowData
                    };
                    this.$store.dispatch('setAgroHistoricalYields', payload).then(()=>{
                        var vm = this;
                        const routes = [
                            {
                                title: '¿Deseas agregar Ingresos por ventas de productos almacenados?',
                                text: 'Si aceptas, podrás agregar o editar la información de Agrícolas / Pecuarios / Animales durante el ciclo a financiar',
                                route: '/asessments/new_asessment/customer/agro/product'
                            },
                            {
                                title: '¿Deseas agregar Ingresos por ventas estacionales?',
                                text: 'Si aceptas, podrás agregar o editar la información de Ingresos por ventas estacionales',
                                route: '/asessments/new_asessment/customer/agro/seasonal_sales'
                            },
                            {
                                title: '¿Deseas agregar Ingresos por jornales o salarios a la actividad agropecuaria?',
                                text: 'Si aceptas, podrás agregar o editar la información de Ingresos por jornales o salarios a la actividad agropecuaria',
                                route: '/asessments/new_asessment/customer/agro/salary'
                            }
                        ];
                        let currentIndex = 0;
                        function askRoute() {
                            if (currentIndex < routes.length) {
                                const current = routes[currentIndex];
                                swal({
                                    title: current.title,
                                    text: current.text,
                                    type: 'info',
                                    showCancelButton: true,
                                    confirmButtonText: 'Si, aceptar',
                                    cancelButtonText: 'No, continuar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                    buttonsStyling: false
                                }).then(() => {
                                    vm.$router.push(current.route); // Redirige a la ruta correspondiente
                                }, (dismiss) => {
                                    if (dismiss === 'cancel') {
                                        currentIndex++; // Avanza al siguiente paso
                                        askRoute(); // Llama recursivamente para mostrar la siguiente pregunta
                                    } else {
                                        swal({
                                            title: 'Cancelado',
                                            text: 'El analista no ha continuado',
                                            type: 'error',
                                            confirmButtonClass: 'btn btn-info btn-fill',
                                            buttonsStyling: false
                                        });
                                    }
                                });
                            } else {
                                vm.$router.push('/asessments/new_asessment/customer/agro/expenses');
                            }
                        }
                        // Llama la función para iniciar el flujo
                        askRoute(); 
                    });
                }
            }
        },
        mounted () {
            this.$nextTick(() => {
                document.addEventListener('wheel', (event) => {
                if (event.target.type === 'number') {
                    event.preventDefault();
                }
                }, { passive: false });
            });
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.historicalYields) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.historicalYields;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.historicalYields) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.historicalYields;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.historicalYields) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.historicalYields;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowData;
            }
            this.calculateMonthlyTotalsByHistoricalName();
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
    /* Cambiar color del texto de los elementos seleccionados en el select */
    .select-warning .el-select__tags .el-tag {
        color: black; /* Cambia esto por el color que desees */
    }
</style>
